import React from "react";
import CardSlider from "./CardSlider";
import User1Image from "./assets/img/user1.png";
import User3Image from "./assets/img/user3.png";
import User4Image from "./assets/img/user4.png";
import User5Image from "./assets/img/user5.png";
import User6Image from "./assets/img/user6.png";

const EventSlider = ({ backgroundColor }) => {
  const cardData = [
    {
      title: "Step 1",
      imageSrc: User1Image,
      heading: "Accessing the Digipass Website",
      subheading:
        "Visitors initiate the appointment booking process by accessing the MPSEDC Digipass website through their preferred web browser...",
    },
    {
      title: "Step 2",
      imageSrc: User6Image,
      heading: "Choosing the Digipass Method",
      subheading:
        "Upon reaching the website, visitors are presented with two convenient options: a chatbot interface or a form.... ",
    },
    {
      title: "Step 3",
      imageSrc: User3Image,
      heading: "Tickets via Chatbot Interface",
      subheading:
        " Visitors opting for the chatbot interface engage with an interactive chatbot that guides them through the appointment booking procedure... ",
    },
    {
      title: "Step 4",
      imageSrc: User4Image,
      heading: " Tickets via Form",
      subheading:
        " Alternatively, visitors who choose the form option fill in the required details, including personal information and appointment  preferences....",
    },
    {
      title: "Step 5",
      imageSrc: User5Image,
      heading: "Identity Verification",
      subheading:
        "To ensure security and authenticity, visitors provide their Aadhar number, Captch, OTP, and upload their current image for identity verification....",
    },
    {
      title: "Step 6",
      imageSrc: User6Image,
      heading: "Successful Registration",
      subheading:
        "Following the completion of the registration process, visitors receive a WhatsApp notification confirming their  successful appointment registration....",
    },
  ];

  const heading = (
    <div>
      Visitor User Journey to Book Tickets for an{" "}
      <span
        style={{
          margin: "0px",
          padding: "0px",
          fontSize: "36px",
          color: "#474747",
          fontWeight: 600,
          borderBottom: "4px solid #107de2",
          fontFamily: "Montserrat, sans-serif",
        }}
      >
        Event
      </span>{" "}
      using Digipass
    </div>
  );

  return (
    <CardSlider
      cardData={cardData}
      heading={heading}
      backgroundColor={backgroundColor}
    />
  );
};

export default EventSlider;
